import { Filter, GlProgram, UniformGroup } from 'pixi.js';

const vertex = `
in vec2 aPosition;
out vec2 vTextureCoord;
uniform vec4 uInputSize;
uniform vec4 uOutputFrame;
uniform vec4 uOutputTexture;
vec4 filterVertexPosition(void) {
    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;
    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0 * uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;
    return vec4(position, 0.0, 1.0);
}
vec2 filterTextureCoord(void) {
    return aPosition * (uOutputFrame.zw * uInputSize.zw);
}
void main(void) {
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`;

const fragment = `
#version 300 es
precision highp float;
in vec2 vTextureCoord;
out vec4 finalColour;
uniform sampler2D uTexture;

uniform vec2 uMouse;
uniform vec2 uSpritePos;

uniform vec4 uInputSize;
uniform vec4 uOutputFrame;

uniform float uTotalAlpha;

void main(void) {

    float distance = 20.0;

    vec4 normalColour = texture(uTexture, vTextureCoord);

    float alpha = normalColour.a;

    if (alpha< 0.5) { finalColour = vec4(0.0); return; } //don't process semi-transparent pixels

    float rot = (alpha-0.5)*2.0 * 6.28318530718; //half of alpha channel used for rotation data
    normalColour.a =  1.0;

    vec2 pixel = vTextureCoord*uInputSize.xy+uOutputFrame.xy;

    vec3 light = vec3( uMouse.x-pixel.x, uMouse.y -pixel.y, distance);

    // vec4 cursor;
    // if (abs(pixel.x-uMouse.x) < 5.0 &&
    //     abs(pixel.y-uMouse.y) < 5.0) {
    //     cursor = vec4(1.0);
    // } else {
    //     cursor = vec4(0.0);
    // }

    // vec2 filterCenter = uOutputFrame.xy + uOutputFrame.zw * 0.5;

    // // cursor at mouse
    // vec4 mouseCursor = (abs(pixel.x - uMouse.x) < 3.0 && abs(pixel.y - uMouse.y) < 3.0)
    //     ? vec4(1.0, 0.0, 0.0, 1.0) : vec4(0.0);

    // // cursor at filter centre
    // vec4 centerCursor = (abs(pixel.x - filterCenter.x) < 3.0 && abs(pixel.y - filterCenter.y) < 3.0)
    //     ? vec4(0.0, 1.0, 0.0, 1.0) : vec4(0.0);

    // // line between mouse and filter centre
    // vec2 lineDir = normalize(uMouse - filterCenter);
    // vec2 toPixel = pixel - filterCenter;
    // float along = dot(toPixel, lineDir);
    // float across = abs(toPixel.x * lineDir.y - toPixel.y * lineDir.x);
    // float onSegment = step(0.0, along) * step(along, length(uMouse - filterCenter));
    // vec4 line = (across < 1.5 && onSegment > 0.0) ? vec4(1.0, 1.0, 0.0, 1.0) : vec4(0.0);


    //offset rgb
     normalColour.x = (normalColour.x - 0.5)*normalColour.a;
     normalColour.y = (normalColour.y - 0.5)*normalColour.a;
    //  normalColour.z = (normalColour.z - 0.5)*normalColour.a;
    
    vec2 n = normalColour.xy;
    n.y = -n.y;

    float s = sin(rot);
    float c = cos(rot);

    n = vec2(
        n.x * c - n.y * s,
        n.x * s + n.y * c
    );

    //normalise for direction
    // vec3 normalVector = normalize(vec3(n, normalColour.z * 2.0 - 1.0));
    vec3 normalVector = vec3(n.x, n.y, normalColour.z);
    light = normalize(light);

    float diffuse = dot(normalVector, light);
    vec3 crazyDichotomy = diffuse > 0.5 ? vec3(1.0) : vec3(0.0);
    float strength = abs(diffuse*2.0-1.0);
    vec4 effect = vec4(vec3(diffuse), normalColour.a*strength)*0.3;

    
    // finalColour = vec4(0.0);
    // finalColour = mouseCursor + centerCursor + line + effect;
    float alphaMult = max(0.0,uTotalAlpha*2.0 - 1.0);
    finalColour = effect*uTotalAlpha;
    
    
//     vec3 n = normalize(vec3(
//     normalColor.r * 2.0 - 1.0,
//     normalColor.g * 2.0 - 1.0,
//     normalColor.b * 2.0 - 1.0
// ));
// n.y = -n.y;
//     vec2 pixelPos = uSpritePos + vTextureCoord * vec2(textureSize(uTexture, 0));
// vec2 lightDir2D = normalize(uMouse - pixelPos);
// vec3 l = normalize(vec3(lightDir2D, 1.0));
//     float lambert = dot(n, l);
// finalColour = lambert > 0.0
//     ? vec4(1.0, 1.0, 1.0, lambert * normalColor.a * 0.3)
//     : vec4(0.0, 0.0, 0.0, -lambert * normalColor.a * 0.3);

}
`;

export class NormalFilter extends Filter {
    constructor() {
        super({
            glProgram: GlProgram.from({ vertex, fragment, name: 'normal-map-filter' }),
            resources: {
                filterUniforms: new UniformGroup({
                    uMouse: { value: [0, 0], type: 'vec2<f32>' },
                    uSpritePos: { value: [0, 0], type: 'vec2<f32>' },
                    uTotalAlpha: {value: 0, type: 'f32'}
                })
            }
        });
    }

    set mouse(value: [number, number]) {
        this.resources.filterUniforms.uniforms.uMouse = value;
    }

    set spritePos(value: [number, number]) {
        this.resources.filterUniforms.uniforms.uSpritePos = value;
    }

    set totalAlpha(value: number) {
        this.resources.filterUniforms.uniforms.uTotalAlpha = value;
    }
}